import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { Tabs } from '@com-delta-omnichannel/mach-core-js';
import { ContentFeedNotification } from './models/notification-feed.models';

@Component({
  selector: 'idp-notification-feed',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notification-feed.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None
})
export class NotificationFeedComponent implements OnInit, AfterViewInit {
  @Input() content: ContentFeedNotification = {} as ContentFeedNotification;
  @Output() closeEvent = new EventEmitter();
  @Output() newsEvent = new EventEmitter();
  isNews = false;
  isAdvisories = true;

  selectedIndexPanel = 0;
  tabsSmallFixedInstance!: Tabs;

  ngOnInit() {
    const el = document.getElementById('notification-feed');
    if (el) {
      el.focus();
    }
  }

  ngAfterViewInit(): void {
    if (!this.content.tabElement) return;
    this.tabsSmallFixedInstance = new Tabs(this.content.tabElement);
    this.onTabClick();
  }

  onTabClick(): void {
    this.tabsSmallFixedInstance.onTabChange((index) => {
      this.selectedIndexPanel = index;
      this.switchTab(this.selectedIndexPanel);
    });
  }

  close(): void {
    this.closeEvent.emit();
  }

  switchTab(n: number): void {
    switch (n) {
      case 0:
        this.isAdvisories = true;
        this.isNews = false;
        break;
      case 1:
        this.isAdvisories = false;
        this.isNews = true;
        this.newsEvent.emit();
        break;
      default:
        this.isAdvisories = false;
        this.isNews = false;
    }
  }
}
